module.exports = __webpack_public_path__ + "static/media/routes13.0be8e41a.webp";